import CloseIcon from '@mui/icons-material/Close';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

interface IScanQRCodeButton {
  onClick: () => void;
  open: boolean;
}

export function ScanQRCodeButton({ onClick, open }: IScanQRCodeButton) {
  return (
    <Button
      color="primary"
      variant={open ? 'text' : 'outlined'}
      onMouseDown={onClick}
      startIcon={open ? <CloseIcon /> : <QrCodeIcon />}
    >
      {open ? (
        <FormattedMessage {...messages.userRfidModalScanQRCloseBtn} />
      ) : (
        <FormattedMessage {...messages.scanQRButtonLabel} />
      )}
    </Button>
  );
}
